// extracted by mini-css-extract-plugin
export default {"l_HistoryBackBtn_main":"HistoryBackBtn_l_HistoryBackBtn_main__fXNIz"};